/**
 * API configuration — plain getters (no Vue reactivity needed).
 * These are evaluated at call time, not import time.
 */

const isLocal = () =>
  window.location.hostname === 'localhost' ||
  window.location.hostname === '127.0.0.1'

export const apiConfig = {
  get baseUrl() {
    return isLocal()
      ? 'http://localhost:5001/dmg-internal-441116/us-east4/dmg_tools'
      : 'https://us-east4-dmg-internal-441116.cloudfunctions.net/dmg_tools'
  },
  get googleClientId() {
    return '812736188745-mklh41c9gao9dsngiv28aahg8v0q8a5n.apps.googleusercontent.com'
  },
  get redirectUri() {
    return isLocal()
      ? 'http://localhost:5001/dmg-internal-441116/us-east4/dmg_tools/oauth2callback'
      : 'https://tools.definemg.com/oauth2callback'
  }
}

export const isLocalEnvironment = { get value() { return isLocal() } }
